module.exports = __webpack_public_path__ + "img/1.42f4dc85.jpg";